module.exports = __webpack_public_path__ + "media/images/results_dates_next-738df2b62e6400f9fd6d84ceb5c95061.svg";